export const RepairStatus = {
  REQUESTED: 'REQUESTED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  IRREPARABLE: 'IRREPARABLE',
} as const;

export type RepairStatus = (typeof RepairStatus)[keyof typeof RepairStatus];

export type Repair = {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  status: RepairStatus;
  // true  -> equipment is in QUARANTINE (do not use)
  // false -> minor defect, equipment stays usable (DAMAGED)
  blocking: boolean;
  // when true, completing the repair does not return the equipment to service:
  // a conform inspection is required first
  requiresReinspection: boolean;
  description: string | null;
  resolution: string | null;
  cost: number | null;
  openedAt: Date;
  startedAt: Date | null;
  completedAt: Date | null;
  organizationId: number;
  equipmentId: number;
  openedByUserId: number | null;
  assignedToUserId: number | null;
  triggeredByInspectionId: number | null;
};
